<template>

    <div>
        <div class="w-full mb-6 pl-12 mx-auto ">
            <h1 class="font-bold text-4xl my-2">Batch Activation</h1>
            <div class="mt-0 mb-4 text-gray-600">
                Make Batch Activation Request Through Excel file.
            </div>
            <hr class="my-8 border-b-2 border-gray-200">
        </div>
        <div class="pl-12 w-full flex justify-center flex-wrap content-center mx-auto" v-if="simcards.length === 0">
            <img class="w-4/12" src="../assets/images/collection.svg">
            <h6 class="text-3xl font-bold text-blue-500 text-center">Download, Fill in, Upload, then Wait For Activation.</h6>
        </div>
        <div class="pl-12 w-full flex justify-center flex-wrap content-center mx-auto" v-if="simcards.length === 0">
            <button type="button"
                    class="py-3 px-3 mx-2 my-2 bg-blue-500 hover:bg-blue-600 rounded text-lg text-white font-bold"
                    :class="{
                        'opacity-50': !preliminaryWorkIsReady,
                    }"
                    :disabled="!preliminaryWorkIsReady"
                    @click="downloadTemplateFile"
                        >
                    Download Template File
            </button>
            <button type="button"
                    accept=".xlsx"
                    class="py-3 px-3 mx-2 my-2 text-lg text-white font-bold rounded border border-blue-500
                            bg-white text-blue-500
                            hover:border-blue-600 hover:bg-blue-600 hover:text-white"
                    :class="{
                        'opacity-50': !preliminaryWorkIsReady,
                    }"
                    :disabled="!preliminaryWorkIsReady"
                    @click="prepareToUpload"
                        >
                    Upload File
            </button>
            <input type="file"
                   ref="uploader"
                   class="hidden"
                   v-if="!fileIsReading"
                   @change="handleFile($event)">
        </div>
        <div class="pl-12 w-full flex justify-center flex-wrap content-center mx-auto" v-if="simcards.length > 0">
            <button type="button"
                    class="py-3 px-3 mx-2 my-2 bg-blue-500 hover:bg-blue-600 rounded text-lg text-white font-bold"
                    @click="activateSimcards"
                        >
                    Submit Activation Request
            </button>
            <button type="button"
                    accept=".xlsx"
                    class="py-3 px-3 mx-2 my-2 text-lg text-white font-bold rounded border border-blue-500
                            bg-white text-blue-500
                            hover:border-blue-600 hover:bg-blue-600 hover:text-white"
                    @click="cancel"
                        >
                    Cancel
            </button>
        </div>
        <div class="pl-12 w-full mx-auto" v-if="simcards.length > 0">
            <table class="table-auto w-full text-sm">
                <thead>
                    <tr>
                        <th class="px-2 py-2">Carrier</th>
                        <th class="px-2 py-2">Simcard No</th>
                        <th class="px-2 py-2">Serial No</th>
                        <th class="px-2 py-2">Activation Date (UTC+8)</th>
                        <th class="px-5 py-2">Return Date (UTC+8)</th>
                        <th class="px-2 py-2">Name</th>
                        <th class="px-2 py-2">Email</th>
                        <th class="px-2 py-2">Contact Phone Number</th>
                        <th class="px-2 py-2">Passport Number</th>
                        <th class="px-2 py-2">Name on Passport</th>
                        <th class="px-2 py-2">Birthday</th>
                        <th class="px-2 py-2">IMEI</th>
                        <th class="px-2 py-2">SIM Card Mobile Number</th>
                        <th class="px-2 py-2">Arrival State or Province</th>
                        <th class="px-2 py-2">Arrival City</th>
                    </tr>
                </thead>
                <tbody class="text-sm">
                    <tr v-for="(simcard, idx) in simcards"
                        :key="idx">
                        <td class="border px-1 py-1">
                            <div class="px-1 py-1 rounded bg-gray-200 tracking-tighter text-xs text-gray-600 truncate">
                                {{ carrierNameMap[simcard._carrierId] }}
                            </div>
                        </td>
                        <td class="border px-1 py-1">
                            {{ simcard.simcard_no }}
                        </td>
                        <td class="border px-1 py-1">
                            {{ simcard.serial_no }}
                        </td>
                        <td class="border px-1 py-1">
                            {{ simcard.act_date }}
                        </td>
                        <td class="border px-1 py-1">
                            {{ simcard.return_date }}
                        </td>
                        <td class="border px-1 py-1">
                            {{ simcard.name }}
                        </td>
                        <td class="border px-1 py-1">
                            {{ simcard.email }}
                        </td>
                        <td class="border px-1 py-1">
                            {{ simcard.tel }}
                        </td>
                        <td class="border px-1 py-1">
                            {{ simcard.passport }}
                        </td>
                         <td class="border px-1 py-1">
                            {{ simcard.passport_name }}
                        </td>
                        <td class="border px-1 py-1">
                            {{ simcard.dob }}
                        </td>
                        <td class="border px-1 py-1">
                            {{ simcard.IMEI }}
                        </td>
                        <td class="border px-1 py-1">
                            {{ simcard.card_account }}
                        </td>
                        <td class="border px-1 py-1">
                            {{ simcard.state }}
                        </td>
                        <td class="border px-1 py-1">
                            {{ simcard.city }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

</template>

<script>
import XLSX from 'xlsx';
import fieldServ from '../services/field.service';
import {
    mapState,
    mapGetters,
    mapMutations,
    mapActions
} from 'vuex';

export default{

    data() {
        return {
            fileIsReading: false,
        }
    },

    computed: {

        ...mapState(
            'act',
            [
                'carriers',
                'simcards',
            ],
        ),

        ...mapGetters(
            'act',
            [
                'preliminaryWorkIsReady',
                'carrierNameMap',
            ],
        ),

    },

    methods: {

        ...mapMutations(
            'act',
            [
                'setSimcards',
            ],
        ),

        ...mapActions(
            'act',
            [
                'activateSimcards',
                'fetchCarriers',
                'reset',
            ]
        ),

        ...mapActions(
            'message',
            [
                'warning',
            ]
        ),

        downloadTemplateFile(){

            const carriers = this.carriers;

            const filename = `batch_act_request_template_${(new Date).getTime()}.xlsx`;

            const wb = XLSX.utils.book_new();
            // const firstSheet = XLSX.utils.aoa_to_sheet(firstSheetData.sheet_content);
            // XLSX.utils.book_append_sheet(wb, firstSheet, firstSheetData.sheet_name);

            carriers.forEach( carrier => {
                const header = Object.entries(carrier.fields)
                                     .filter(ary => ary[1])
                                     .map(ary => fieldServ.getFieldsNameByKey(ary[0]))
                                     .flat();
                const sheet = XLSX.utils.json_to_sheet(
                    [],
                    {
                        header,
                    });
                    XLSX.utils.book_append_sheet(wb, sheet, carrier.name);
            });

            XLSX.writeFile(wb, filename);

        },

        prepareToUpload(){

            const elUploader = this.$refs['uploader'];
            elUploader.click();

        },

        handleFile(e) {
            const NAME_SIMCARD_NO = fieldServ.NAME_SIMCARD_NO;
            const validCarrierNames = this.carriers.map(carrier => carrier.name);
            const mapOfNameToField  = fieldServ.getMapOfNameToField();
            const mapOfNameToFieldAsArray = Object.entries(mapOfNameToField);
            const files = e.target.files, f = files[0];
            const reader = new FileReader();
            let errorMessages = [];

            this.setSimcards([]);

            reader.onload = e => {
                this.fileIsReading = false;
                const data = new Uint8Array(e.target.result);
                const wb = XLSX.read(data, {type: 'array'});
                const carrierNamesInSheets = wb.SheetNames;
                let validSimcards = [];

                //check all carrier name is valid.
                let invalidCarrierNames = carrierNamesInSheets.filter(carrierName => !~validCarrierNames.indexOf(carrierName));

                if(invalidCarrierNames.length > 0 ){
                    return this.warning({
                        title: 'Invalid Data In Sheets',
                        content: `Invalid Carrier/Sheet Name: ${invalidCarrierNames.join(', ')}`,
                        sec: 5000
                    });
                }

                //validate through carrier condition
                this.carriers.forEach(carrier => {
                    const carrierId   = carrier.id;
                    const carrierName = carrier.name;
                    const fieldKeys   = carrier.fields;
                    const requireFieldKey = Object.entries(fieldKeys)
                                                    .filter(ary => ary[1])
                                                    .map(ary => ary[0]);
                    const requireFields = requireFieldKey.map( key => fieldServ.getFields(key) )
                                                             .flat();

                    const simcards    = XLSX.utils.sheet_to_json(wb.Sheets[carrierName]);

                    simcards.forEach(simcard => {

                        let numOfErrorMsgsBeforeCheck = errorMessages.length;
                        //check require fields
                        requireFields.forEach(requiredField => {
                            const simcardNo = simcard[NAME_SIMCARD_NO];
                            const label = `[ Simcard No: ${simcardNo ? simcardNo : 'N/A'} ] `;
                            //check require fields & validate field content
                            if(!simcard.hasOwnProperty(requiredField.name)) {
                                errorMessages.push(
                                    `${label}${requiredField.name} is required field for ${carrierName}'s simcard`
                                );
                            }else{
                                const fieldErrors = requiredField.validate(simcard[requiredField.name], simcard);
                                if(fieldErrors.length > 0) {
                                    errorMessages = errorMessages.concat(fieldErrors.map( msg => `${label}${msg}` ));
                                }
                            }
                        });

                        if(errorMessages.length == numOfErrorMsgsBeforeCheck){
                            const simcardFormatted = mapOfNameToFieldAsArray.reduce((tmp, [name, field]) => {
                                tmp[field] = simcard[name];
                                return tmp;
                            }, {'_carrierId': carrierId});
                            validSimcards.push(simcardFormatted);
                        }

                    });

                });

                if (errorMessages.length > 0) {
                    return this.warning({
                        title: 'Invalid Data In Sheets',
                        content: errorMessages,
                        sec: 15000
                    });
                }

                if(validSimcards.length === 0 ){
                    return this.warning({
                        title: 'No Data In Sheets',
                        content: 'No any valid simcard data in the sheets',
                        sec: 3000
                    });
                }

                this.setSimcards(validSimcards);

            };
            reader.readAsArrayBuffer(f);
            this.fileIsReading = true;
        },

        cancel() {
            this.setSimcards([]);
        },

        activate() {
            this.activateSimcards();
        },

    },

    created() {
        this.fetchCarriers();
    },

    destroyed() {
        this.reset();
    },

}

</script>
